import { render, staticRenderFns } from "./AccountDiscounts.vue?vue&type=template&id=03779c18"
import script from "./AccountDiscounts.vue?vue&type=script&lang=js"
export * from "./AccountDiscounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports